export const KarnovLogo = () => (
  <svg
    width="77"
    height="24"
    viewBox="0 0 77 24"
    className="fill-current text-default"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.96"
      d="M0.272955 21.1403V2.97451L0 0.496094H3.93656L3.6636 2.97198V21.1378L3.93656 23.6136H0L0.272955 21.1378V21.1403ZM11.7546 24.0019C9.26793 19.983 6.64356 15.9641 3.93656 12.0561L5.19365 10.9014C7.40733 7.43212 9.51334 3.9099 11.4816 0.496094H14.7621V0.662498C12.1928 4.35112 9.75875 7.70946 7.35475 10.9846C9.73371 14.3429 12.2479 18.0038 14.7621 21.8009L11.7546 24.0019Z"
    />
    <path
      opacity="0.96"
      d="M30.015 23.9445L27.884 16.6228H20.6945C20.0384 18.9625 19.3548 21.2745 18.6987 23.6142H15.5835C18.1528 16.0177 20.6945 8.42105 23.0735 0.824456L26.3539 0C28.6778 7.65206 31.0292 15.3016 33.4608 22.9537L30.0175 23.9445H30.015ZM27.1452 14.0914C26.2162 10.8717 25.3147 7.6798 24.3831 4.45761H24.0551C23.2087 7.67728 22.3047 10.8692 21.4032 14.0914H27.1427H27.1452Z"
    />
    <path
      opacity="0.96"
      d="M36.3579 21.1378V2.97198L36.085 0.496094H40.0215L39.7486 2.97198V21.1378L40.0215 23.6136H36.085L36.3579 21.1378Z"
    />
    <path
      opacity="0.96"
      d="M44.5592 21.1378V2.97198L44.2862 0.496094H48.2228L47.9498 2.97198V20.8629H55.2745L57.7336 20.5881L57.1326 23.6162H44.2837L44.5566 21.1403L44.5592 21.1378Z"
    />
    <path
      opacity="0.96"
      d="M73.4799 23.9445L71.3488 16.6228H64.1593C63.5033 18.9625 62.8196 21.2745 62.1635 23.6142H59.0483C61.6176 16.0177 64.1593 8.42105 66.5383 0.824456L69.8188 0C72.1426 7.65206 74.4941 15.3016 76.9256 22.9537L73.4824 23.9445H73.4799ZM70.6101 14.0914C69.681 10.8717 68.7795 7.6798 67.848 4.45761H67.5199C66.6735 7.67728 65.7695 10.8692 64.868 14.0914H70.6076H70.6101Z"
    />
  </svg>
)
